import enLocaleMessages from './i18n/en.json';
import frLocaleMessages from './i18n/fr.json';


export const i18nConfig: any = {
    en: enLocaleMessages,
    fr: frLocaleMessages
};